import React from 'react';


const PageTitle = ({ title, icon }) => {
    return (
        <div className="page-title flex flex-col gap-2">
            <h1 className="lg:text-3xl min-[320px]:text-lg font-bold text-primary">{title}</h1>
            <div className="flex flex-row gap-1">
                {icon}
                <p className="text-xs">/ {title}</p>
            </div>

        </div>
    )
}
export default PageTitle;